import type { ContentEntity } from "shared/schema";
import { useStore } from "shelving/react";
import { SET_REACTION } from "shared/api";
import { Button, Icon, Loader, useDialog } from "shared/react";
import { EARNED_MAX, PRIVATE_PRIVACIES } from "shared/schema";
import { RewardIcon } from "../reward/RewardIcon.js";
import { TrajectoryEarnedRewardPicker } from "../reward/RewardPicker.js";
import { callAPI } from "../util/api.js";
import { useReactorItem } from "../util/data.js";
import { USER } from "../util/user.js";

export function ReactButton({ target }: { target: ContentEntity }): React.ReactElement {
	const showDialog = useDialog();
	const item = useReactorItem(target);
	useStore(item.busy);
	const loading = item.loading || item.busy.value;
	return (
		<Button
			mods={`button-quiet ${loading ? "effect-waiting" : ""}`}
			title={loading ? "Loading..." : item.value?.reaction ? "Clear reaction" : "React to this"}
			onClick={
				loading
					? undefined
					: async () => {
							const currentReaction = item.value?.reaction;
							if (currentReaction) {
								// If there's already a reaction remove it...
								item.busy.set(true);
								await callAPI(SET_REACTION, { target, reaction: currentReaction });
								item.busy.set(false);
							} else {
								// ...or show a modal to pick the new reaction.
								showDialog(
									<article className="modal">
										<Loader>
											<TrajectoryEarnedRewardPicker //
												type="reaction"
												query={{
													uid: USER.data.uid,
													type: "reaction",
													privacy: PRIVATE_PRIVACIES,
													$order: "!created",
													$limit: EARNED_MAX,
												}}
												onPick={async nextReaction => {
													item.busy.set(true);
													await callAPI(SET_REACTION, { target, reaction: nextReaction });
													item.busy.set(false);
												}}
											/>
										</Loader>
									</article>,
								);
							}
					  }
			}
		>
			{item.value?.reaction ? <RewardIcon id={item.data.reaction} type="reaction" /> : <Icon icon="reaction" />}
		</Button>
	);
}
